import {DATA_TYPE} from "../../constants";

export const historySchema = {
    "historyChangeDetail": {
        "field": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "target": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "before": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "after": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
    }
} as const;
